import React, { useEffect, useState } from "react";
import { fileNameExtension } from "../../../utilities/constants/regularexpressions";
import { getBase64 } from "../../../utilities/fileFunctions/imageFunctions";
import { fileTypeChecker } from "../../../utilities/validateDocuments/validateDocument";
import Error from "../../outputs/Error";

export default function PDFImageUploader({
  register,
  defaultName,
  name,
  required,
  pattern,
  errors,
  classes,
  setError,
  clearError,
  file,
  setBase64,
  setFilename,
  setValue,
  isEdit,
  oldFileOnEdit,
  fileUploadError,
  setFileUploadError,
  ...rest
}) {
  const { onChange, ...props } = register(defaultName, {
    required: { value: required, message: `${name} is required` },
    pattern: pattern,
  });

  const onChangeDocument = async (e) => {
    try {
      let fileType = "";
      await fileTypeChecker(e.target.files[0])
        .then((file) => {
          fileType = file;
          setFileUploadError(false);
        })
        .catch((err) => {
          setFileUploadError(true);
          console.error("Invalide File:", err);
        });

      if (
        fileType !== "unknown" &&
        fileNameExtension.test(e.target.files[0].name) //testing file name
      ) {
        rest?.setFile(e.target.files[0]);
        getBase64(e.target.files[0], (result) => {
          setValue(defaultName, result);
          setBase64(result);
        });

        setFilename(e.target.files[0].name);
      } else {
        setFileUploadError(true);
      }
    } catch (error) {
      console.error("some error", error);
    }
  };
  return (
    <div className="flex flex-col max-full mb-4 justify-center">
      <label className="font-medium text-left mb-1">
        {name} {required && <span className="text-red-700">*</span>}
      </label>
      <input
        id={defaultName}
        // defaultValue={file !== "" ? dataURLtoFile(file) : null}
        accept="application/pdf, image/*"
        onChange={(e) => {
          if (required) {
            if (e.target.value === "") {
              setError(defaultName, {
                type: "required",
                message: `${name} is required`,
              });
            } else {
              onChangeDocument(e);
              clearError(defaultName);
            }
          } else {
            onChangeDocument(e);
            clearError(defaultName);
          }

          onChange(e);
        }}
        {...props}
        {...rest}
        className={`${classes} border ${
          errors[defaultName] ? "border-red-700" : "border-slate-300"
        }`}
      />
      {/* <img src */}

      {errors[defaultName] && (
        <Error
          classes="flex flex-row gap-1 max-w-sm w-full mt-2"
          message={`${name} is required`}
        />
      )}

      {fileUploadError && (
        <Error
          classes="flex flex-row gap-1 max-w-sm w-full mt-2"
          message={`Uploaded ${name} is invalid or has invalid name`}
        />
      )}
    </div>
  );
}
